// Real screenshots of the app, taken on a phone (public/assets/app/, 9 Oct 2026, app 4.2.7 build 63, logged out,
// no personal data; the status bar is painted over). A screen listed here is shown in a phone frame; a screen
// left out is shown as a feature card instead of a drawing.
//
// "emergency" and "acompaname" are left out ON PURPOSE: both need a logged-in account, and the person capturing
// must not type credentials. The emergency tab uses the home screen (it shows the same "!" button). Add them
// here (and drop the file in public/assets/app/) once someone logged in has captured them.
export type AppScreen = { src: string; alt: string };

export type ScreenKey = 'home' | 'directory' | 'quiz' | 'emergency' | 'acompaname' | 'lineas';

export const SCREENS: Partial<Record<ScreenKey, AppScreen>> = {
  home: {
    src: '/assets/app/inicio.jpg',
    alt: 'Pantalla de inicio de la app Violeta: acceso al Violentómetro y a artículos, y el botón de emergencia (!) en el centro de la barra inferior.',
  },
  directory: {
    src: '/assets/app/directorio.jpg',
    alt: 'Directorio de servicios de la app Violeta, con búsqueda y filtros por estado y por tipo de servicio.',
  },
  quiz: {
    src: '/assets/app/violentometro.jpg',
    alt: 'Violentómetro de la app Violeta, con las pestañas Educación, Evaluación y Resultados.',
  },
  lineas: {
    src: '/assets/app/lineas.jpg',
    alt: 'Pantalla de Líneas de Atención de la app Violeta, con las líneas de Violeta y un botón para llamar a cada una.',
  },
};
